import { createSlice } from "@reduxjs/toolkit";
import { updateCourse } from "services/course/course";

const initialState = {
    course : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const updateCourseSlice = createSlice({
    name: 'updateCourse',
    initialState,
    extraReducers: {
        [updateCourse.pending]: (state) => {
            state.course.isLoading = true;
        },
        [updateCourse.fulfilled]: (state, { payload }) => {
            state.course.isLoading = false;
            state.course.isSuccess = true;
            state.course.data = payload;
        },
        [updateCourse.rejected]: (state, { payload }) => {
            state.course.isLoading = false;
            state.course.isSuccess = false;
            state.course.errorMessage = payload
        }
    }
})

export default updateCourseSlice.reducer;
